import React, { ReactNode } from 'react';
import { hasPermission } from 'helpers/permissions';

interface PermissionWrapperProps {
  allowedRoles: string[];
  children: ReactNode;
  fallback?: ReactNode;
}

/**
 * Generic wrapper component to conditionally render children based on user permissions
 * @param allowedRoles - Array of roles that are allowed to see the content
 * @param children - Content to render if user has permission
 * @param fallback - Optional content to render if user doesn't have permission (default: null)
 */
const PermissionWrapper: React.FC<PermissionWrapperProps> = ({
  allowedRoles,
  children,
  fallback = null,
}) => {
  const hasAccess = hasPermission(allowedRoles);

  if (!hasAccess) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

export default PermissionWrapper;

